<template>
  <div class="aside-menu flex-column-fluid">
    <div id="kt_aside_menu_wrapper"
         class="hover-scroll-overlay-y my-5 my-lg-5"
         data-kt-scroll="true"
         data-kt-scroll-activate="{default: false, lg: true}"
         data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
         data-kt-scroll-height="auto"
         data-kt-scroll-offset="0"
         data-kt-scroll-wrappers="#kt_aside_menu">
      <div id="#kt_aside_menu"
           class="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500"
           data-kt-menu="true" data-kt-menu-expand="false">

        <div class="menu-item" v-for="(item, index) in menu" :key="index">
          <router-link class="menu-link" :class="{ 'active': activateUrl(item.group) }" :to="item.route">
            <div class="menu-icon mr-3">
              <i class="fs-3" :class="item.icon"></i>
            </div>
            <span class="menu-title">{{ item.title }}</span>
          </router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import i18n from '@/plugins/i18n'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const menu = computed(() => {
    return [
        {
            title: i18n.global.t('landlord.menu.dashboard'),
            icon: 'fas fa-home',
            route: '/landlord/dashboard',
            group: ['landlord-dashboard'],
        },
        {
            title: i18n.global.t('landlord.menu.shops'),
            icon: 'fas fa-store',
            route: '/landlord/shops',
            group: ['landlord-shops', 'landlord-shop-detail', 'landlord-shop-create'],
        },
        {
            title: i18n.global.t('landlord.menu.societies'),
            icon: 'fas fa-building',
            route: '/landlord/societies',
            group: ['landlord-societies', 'landlord-society-detail'],
        },
        {
            title: i18n.global.t('landlord.menu.modules'),
            icon: 'fas fa-puzzle-piece',
            route: '/landlord/modules',
            group: ['landlord-modules'],
        },
        {
            title: i18n.global.t('landlord.menu.plans'),
            icon: 'fas fa-layer-group',
            route: '/landlord/plans',
            group: ['landlord-plans', 'landlord-plan-detail'],
        },
        {
            title: i18n.global.t('landlord.menu.tickets'),
            icon: 'fas fa-headset',
            route: '/landlord/tickets',
            group: ['landlord-tickets'],
        },
        {
            title: i18n.global.t('login_log.title'),
            icon: 'fas fa-user-shield',
            route: '/landlord/login-logs',
            group: ['landlord-login-logs'],
        },
        {
            title: i18n.global.t('landlord.menu.settings'),
            icon: 'fas fa-cog',
            route: '/landlord/settings',
            group: ['landlord-settings', 'landlord-settings-support'],
        },
    ]
})

function activateUrl(group) {
    return group.includes(route.name)
}
</script>
